export default __webpack_public_path__ + "static/media/btnAndroid.53d7e82d.svg";